/**
 * Single product — AJAX add-to-cart.
 *
 * Standardowy WC `wc-add-to-cart.js` obsługuje tylko archive (`.ajax_add_to_cart`).
 * Na single product klik „Dodaj do koszyka" submit'uje formularz POST → przeglądarka
 * przeładowuje stronę z redirect na koszyk. Chcemy AJAX → otwarcie side-cart drawer.
 *
 * Strategia:
 *   1. Intercept `submit` na `form.cart` (skip grouped/external — inna logika WC).
 *   2. Build FormData; dla variable product `product_id` = `variation_id` (wymaganie WC_AJAX::add_to_cart).
 *   3. POST → /?wc-ajax=add_to_cart.
 *   4. Trigger jQuery `added_to_cart` + `wc_fragment_refresh` → side-cart.js łapie i otwiera drawer.
 *   5. Error → fallback do native form.submit() (graceful degradation).
 */

const WC_AJAX_URL = window.location.origin + '/?wc-ajax=%%endpoint%%';

function buildPayload(form) {
    const fd = new FormData(form);

    // product_id z buttona (WC: <button name="add-to-cart" value="{product_id}">)
    let productId = fd.get('add-to-cart');
    if (!productId) {
        const btn = form.querySelector('button[name="add-to-cart"]');
        if (btn) productId = btn.value;
    }

    // Variable product: WC_AJAX::add_to_cart oczekuje product_id = variation_id
    // (musi resolve'ować do WC_Product_Variation, nie parent).
    const variationId = (fd.get('variation_id') || '').toString().trim();
    if (variationId && variationId !== '0') {
        fd.set('product_id', variationId);
    } else if (productId) {
        fd.set('product_id', String(productId));
    }

    // KRYTYCZNE: usuń `add-to-cart` z payloadu wc-ajax. Inaczej na tym samym request'cie
    // odpala się TEŻ `WC_Form_Handler::add_to_cart_action()` (wp_loaded, czyta $_REQUEST['add-to-cart'])
    // OBOK `WC_AJAX::add_to_cart()` → produkt dodaje się DWA razy (np. 6 → 12).
    fd.delete('add-to-cart');

    return fd;
}

function shouldSkip(form) {
    // Grouped + external — WC handle special. Subscription i prosty simple — OK.
    return form.classList.contains('grouped_form') || form.classList.contains('external_form');
}

async function handleSubmit(event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.classList.contains('cart')) return;
    if (shouldSkip(form)) return;

    // Variable product bez wybranej wariacji — pozwól WC pokazać prompt "Wybierz opcje".
    // wc-add-to-cart-variation.js dba o validation; my się wycofujemy z preventDefault.
    const variationIdInput = form.querySelector('input[name="variation_id"]');
    if (variationIdInput) {
        const vid = (variationIdInput.value || '').trim();
        if (!vid || vid === '0') {
            return; // native form behavior — WC pokaże komunikat
        }
    }

    event.preventDefault();

    const submitBtn = form.querySelector('button[name="add-to-cart"], button[type="submit"]');
    if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.classList.add('loading');
    }

    const fd = buildPayload(form);
    const endpoint = WC_AJAX_URL.replace('%%endpoint%%', 'add_to_cart');

    try {
        const res = await fetch(endpoint, {
            method: 'POST',
            credentials: 'same-origin',
            body: fd,
        });
        const data = await res.json().catch(() => ({}));

        if (data && data.error) {
            // WC przy invalid variation/missing attrs często zwraca product_url do reloadu.
            if (data.product_url) {
                window.location.href = data.product_url;
                return;
            }
            // Inne błędy (np. out of stock) — fallback do natywnego submitu,
            // żeby WC notice się pokazał na PDP po reloadzie.
            form.submit();
            return;
        }

        // Success — trigger eventów dla fragmentów i side-cart drawera.
        if (window.jQuery) {
            const $btn = window.jQuery(submitBtn || form);
            window.jQuery(document.body).trigger('added_to_cart', [
                data.fragments || null,
                data.cart_hash || '',
                $btn,
            ]);
            window.jQuery(document.body).trigger('wc_fragment_refresh');
        }
        document.dispatchEvent(new CustomEvent('hn:cart:updated', { detail: data }));

        if (submitBtn) {
            submitBtn.classList.remove('loading');
            submitBtn.classList.add('added');
            setTimeout(() => submitBtn.classList.remove('added'), 2500);
        }
    } catch (err) {
        // Sieć padła — degradacja do native submit (przeładowanie strony).
        form.submit();
    } finally {
        if (submitBtn) {
            submitBtn.disabled = false;
        }
    }
}

export function initSingleProductATC() {
    // Capture phase — wygrywa z innymi listenerami (np. FunnelKit), gwarantuje preventDefault.
    document.addEventListener('submit', handleSubmit, true);
}
